import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import router from './router'
import { vLazyImg } from './composables'
import { initMetrics } from './utils/metrics'
import './styles/index.scss'

const app = createApp(App)

app.directive('lazy-img', vLazyImg)

// 全局错误处理（后续可对接监控平台如 Sentry）
app.config.errorHandler = (err, instance, info) => {
  console.error('[Vue Error]', { err, component: instance?.$options?.name, info })
}

window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  console.error('[Unhandled Promise Rejection]', event.reason)
})

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(router)

initMetrics(router, app)

app.mount('#app')
